/**
 * File Overview
 */


/**
 * A hash of social links to add to the hero section.
 * @type {Object}
 */
export const socialLinks = {
  linkedin: { title: 'LinkedIn', icon: 'linkedin', href: 'https://www.linkedin.com/in/zachvollink/' },
  github: { title: 'Github', icon: 'github', href: 'https://github.com/zvollink' },
  instagram: { title: 'Instagram', icon: 'instagram', href: 'https://www.instagram.com/zachvollink/' },
  airbnb: { title: 'Airbnb', icon: 'airbnb', href: 'https://airbnb.com/h/cozy-cottage-in-lake-city' },
  spotify: { title: 'Spotify', icon: 'spotify', href: 'https://open.spotify.com/user/1243407866?si=e3e016b095754570' },
};


/**
 * Navigation links.
 * @type {Object}
 */
export const navLinks = {
  'About': { id: 'about-me', href: '#about-me', ref: 'aboutMe' },
  'Work': { id: 'work', href: '#work', ref: 'work' },
  'Projects': { id: 'projects', href: '#projects', ref: 'projects' },
  'Blogs': { id: 'blogs', href: '#blogs', ref: 'blogs' }
};


/**
 * A hash of my skills to include in the tool belt.
 * @type {Object}
 */
export const tools = {
  'react': { title: 'React', icon: '' },
  'javascript': { title: 'JavaScript', icon: '' },
  'reactnative': { title: 'React Native', icon: '' },
  'html': { title: 'HTML', icon: '' },
  'css': { title: 'CSS', icon: '' },
  'sass': { title: 'Sass', icon: '' },
  'tailwind': { title: 'Tailwind CSS', icon: '' },
  'python': { title: 'Python', icon: '' },
  'php': { title: 'PHP', icon: '' },
  'redux': { title: 'Redux', icon: '' },
  'axios': { title: 'Axios', icon: '' },
  'ajax': { title: 'AJAX', icon: '' },
  'nodejs': { title: 'Node.js', icon: '' },
  'bash': { title: 'Bash/shell', icon: '' },
  'npm': { title: 'npm', icon: '' },
  'ejs': { title: 'EJS', icon: '' },
  'nunjucks': { title: 'Nunjucks', icon: '' },
  'api': { title: 'API Integration', icon: '' },
  'unittest': { title: 'Unit Testing', icon: '' },
  'googlecloudfunctions': { title: 'Google Cloud Functions', icon: '' },
  'vercel': { title: 'Vercel', icon: '' },
  'firebase': { title: 'Firebase', icon: '' },
  'wordpress': { title: 'WordPress', icon: '' },
  'git': { title: 'Git', icon: '' },
  'uiux': { title: 'UI/UX', icon: '' },
  'figma': { title: 'Figma', icon: '' },
  'adobecc': { title: 'Adobe Creative Cloud', icon: '' }
};


/**
 * A hash of projects I have worked on.
 * @type {Object}
 */
export const projectsList = {
  'highlights': {
    href: 'https://highlightskids.com/',  
    title: 'Highlights Kids',
    description: 'Collaborated with designers to turn pixel mocks into engaging, interactive experiences for children, enhancing educational content with intuitive, user-friendly interfaces and significantly improving the digital presence of Highlights Kids.'
  },
  'bluprint': {
    href: 'https://bluprint.bitsbox.com/',
    title: 'Bluprint',
    description: 'Contributed to frontend, backend, and core system development for Bluprint by Bitsbox, a 3D coding platform where kids can graduate from the original 2D Bitsbox product to code, build worlds, and play games together online.'
  },
  'stemscopes': {
    href: 'https://bitsboxcms.com/demo/?student&licensed/',
    title: 'STEMscopes Coding',
    description: 'Led the frontend development for the STEMscopes Coding product, transforming pixel mocks into interactive elements in collaboration with the lead designer, ensuring a fun and engaging experience to enhance STEM education for students.'
  },
  'bitsbox': {
    href: 'https://bitsbox.com/',
    title: 'Bitsbox',
    description: 'Managed the Bitsbox site over 7 years, balancing efforts between designing and developing engaging frontend experiences within the kids coding environment, and crafting attractive landing pages in collaboration with marketing and other designers to attract customers and boost sales.'
  },
  'bitsbox-store': {
    href: 'https://subscribe.bitsbox.com/',
    title: 'Bitsbox Store',
    description: 'Designed and developed the Bitsbox Store page, creating a visually appealing and user-friendly interface optimized for desktop and mobile devices. Collaborated with the marketing team to align the page\'s design with campaign goals, driving higher engagement and conversions.'
  },
  'woodwork-by-case': {
    href: 'https://woodworkbycase.com/',
    title: 'Woodwork by Case',
    description: 'Put together a portfolio and inquiry site for Case Vollink, a custom carpenter based in Fort Worth, Texas. The site features a gallery showcasing 20+ client and original woodworking projects with lightbox functionality, a contact form with file upload for project references, and a mobile-responsive layout.'
  },
  'skoolie-locker-rentals': {
    href: 'https://skoolielockers.com/',
    title: 'Skoolie Locker Rentals',
    description: 'Built a single-page application (SPA) using React for a local mobile locker service, leveraging Vercel for deployment, Tailwind CSS for styling, and Google Analytics for performance tracking. Worked closely with the client throughout the project to ensure site functionality and design aligned with their vision.'
  }
}